import React from "react";
import { FormControl, Input } from "@chakra-ui/react";
import "../styles/quill.cordia.css";
import { Content } from "../../../common/types";
import Editor from "./Editor";
import TinyEditor from "./TinyEditor";

export type NoteDataInput = Pick<Content, 'title' | 'content'>

interface OwnProps {
    dataRef: React.MutableRefObject<NoteDataInput>;
}

const NoteContentForm = ({
    dataRef,
}: OwnProps) => {

    return (
        <form>
            <FormControl isRequired marginBottom="10px">
                <Input
                    variant="flushed"
                    size="lg"
                    type="text"
                    placeholder="Título del Contenido"
                    _placeholder={{ color: "black", fontWeight: "bold" }}
                    isRequired
                    autoFocus
                    defaultValue=""
                    onChange={(e) => { dataRef.current = {...dataRef.current, title: e.target.value}; }}
                />
            </FormControl>
            <FormControl>
                    <TinyEditor defaultValue="" onChange={(v) => {
                        dataRef.current = {...dataRef.current, content: v};
                    }} />
            </FormControl>
        </form>
    );
};

export default NoteContentForm;
